<template>
    

<div id="print_page" v-if="loaded">

    <div v-if="isPaid" class="paid_stamp">שולם</div>

    <!-- לוגיסטיקה: מספר חבילות ואיתור מדף - מהאדמין אם הוזן, אחרת קו למילוי ידני -->
    <div class="logistic_box">
        <div><span>מספר חבילות:</span><b v-text="(order_data.packages_count > 0 ? order_data.packages_count : '')"></b></div>
        <div><span>איתור מדף:</span><b v-text="(order_data.shelf_location || '')"></b></div>
    </div>

    <div style="text-align:center">
        <div class="logo" style="display: inline-block;">סוכות נחלים</div>
        <div class="logo_subtitle">מחשבון סוכה</div>
        <h2 v-if="userType == 3 || !show_price" class="print_doc_title">תעודת משלוח</h2>
        <div v-if="userType == 3 || !show_price" class="company_details">
            <div>סוכות נחלים</div>
            <div>ח.פ 514066232</div>
            <div>הירדן 13 יבנה</div>
        </div>
    </div>

   <div id="print">
       
       
             
        <div id="summary_details">

            <!-- Motot Summary -->
            <div v-if="active_motot_summary.length > 0" id="motot_summary" class="logistic_summary">
                <div class="title_small">סיכום ברזל</div>
                <table>
                    <tbody>
                        <template v-for="group in active_motot_summary">
                            <tr class="motot_group" :key="group.key">
                                <td colspan="3" v-text="group.title"></td>
                            </tr>
                            <tr v-for="(row,i) in group.items" :key="group.key + '_' + i">
                                <td v-text="row.makat"></td>
                                <td v-text="row.units"></td>
                                <td v-text="row.name"></td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <!-- Motot Summary End -->

            <table>
                <thead>
                    <tr>
                        <th>מק"ט</th>
                        <th>יח'</th>
                        <th>שם המוצר</th>
                        <th v-if="show_price">מחיר</th>
                    </tr>
                </thead>
                <tbody>
                <template v-for="category in basket">
                    <template v-if="active_items(category.items).length > 0 || summary_groups(category.id).length > 0" :class="(order.summary_check_parse.type == 'false' ? 'unactive' : '')">
                    <tr :key="category.id"><td colspan="4" style="font-weight:bold; padding-top:;text-align:center">{{category.name}}</td></tr>
                    <template v-for="item in active_items(category.items)">
                    <tr v-if="item.original_name && item.units > 0" :key="item.id + '_original'" style="font-weight:bold; background-color:#f0f0f0;">
                                <td></td>
                                <td v-text="item.original_units"></td>
                                <td v-text="item.original_name"></td>
                                <td></td>
                    </tr>
                    <tr :key="item.id">
                        <template v-if="item.units > 0">
                                <td v-text="item.makat"></td>
                                <td v-text="item.units"></td>
                                <td v-html="item.name"></td>
                                <td v-if="show_price">₪{{format_number(item.price * item.units)}}</td>
                        </template>
                    </tr>
                    </template>
                    <!-- סיכום במבוקים / לייסטים / חבקים - מוצג בתוך הקטגוריה שלהם (סכך) -->
                    <template v-for="(group,g) in summary_groups(category.id)">
                        <tr class="motot_group" :key="'sum_' + category.id + '_' + g">
                            <td colspan="4" v-text="group.title"></td>
                        </tr>
                        <tr v-for="(row,i) in group.items" :key="'sum_' + category.id + '_' + g + '_' + i">
                            <td v-text="row.makat"></td>
                            <td v-text="row.units"></td>
                            <td v-text="row.name"></td>
                            <td v-if="show_price">₪{{format_number(row.price * row.units)}}</td>
                        </tr>
                    </template>
                    <tr v-if="show_price" :key="category.id"><td colspan="4" style="font-weight:bold;">סה"כ {{category.name}}<div style="float:left;">₪{{format_number(category_total(category))}}</div></td></tr>
                    </template>
                </template>

                    <!-- סיכומים שאין להם קטגוריה בסל (הגיעו ממוצרים נוספים) -->
                    <template v-if="orphan_summary_groups.length > 0">
                        <tr key="orphan_summary"><td colspan="4" style="font-weight:bold; padding-top:5px; text-align:center">סיכום במבוקים / לייסטים</td></tr>
                        <template v-for="(group,g) in orphan_summary_groups">
                            <tr class="motot_group" :key="'orphan_' + g">
                                <td colspan="4" v-text="group.title"></td>
                            </tr>
                            <tr v-for="(row,i) in group.items" :key="'orphan_' + g + '_' + i">
                                <td v-text="row.makat"></td>
                                <td v-text="row.units"></td>
                                <td v-text="row.name"></td>
                                <td v-if="show_price">₪{{format_number(row.price * row.units)}}</td>
                            </tr>
                        </template>
                    </template>

                    <template v-if="active_items(accessories.items).length > 0" :class="(order.summary_check_parse.type == 'false' ? 'unactive' : '')">
                    <tr :key="accessories.id"><td colspan="4" style="font-weight:bold; padding-top:5px">{{accessories.title}}</td></tr>
                    <tr :key="item.id" v-for="item in active_items(accessories.items)">
                        <template v-if="item.units > 0">
                                <td v-text="item.makat"></td>
                                <td v-text="item.units"></td>
                                <td v-html="item.name"></td>
                                <td v-if="show_price">₪{{format_number(item.price * item.units)}}</td>
                        </template>
                    </tr>
                    <tr v-if="show_price" :key="accessories.id"><td colspan="4" style="font-weight:bold;">סה"כ {{accessories.title}}<div style="float:left;">₪{{format_number(category_total(accessories))}}</div></td></tr>
                    </template>

                </tbody>
                <tfoot>
                    <tr v-if="show_price"><td colspan="4" style="font-weight:bold;">סה"כ למוצרים<div style="float:left;">₪{{format_number(total_price_before_discount)}}</div></td></tr>

                    <tr v-if="order.delivery_type == '3'">
                        <td>סוג משלוח</td><td></td><td>משלוח לכניסה לבניין</td>
                        <td v-if="show_price && order.free_delivery == '1'">₪0</td>
                        <td v-else-if="show_price">₪{{delivery_price}}</td>
                    </tr>
                    <tr v-if="order.delivery_type == '1'">
                        <td>סוג משלוח</td><td></td><td>איסוף עצמי</td><td v-if="show_price">₪0</td>
                    </tr>
                    <tr v-if="order.delivery_type == '4'">
                        <td>סוג משלוח</td><td></td><td> משלוח מצורף</td><td v-if="show_price">₪0</td>
                    </tr>
                    <tr v-if="order.discount_amount > 0 && show_price">
                        <td>הנחה</td><td></td><td v-text="order.discount_description"></td><td v-text="order.discount_amount + (order.discount_is_percent == '1' ? '%' : '₪') + '-'"></td>
                    </tr>
                    <div v-if="order.discounts && order.discounts.length > 0 && userType != 2 && show_price">
                        <b> שובר</b>: 
                        <div v-for="(discount,i) in order.discounts" :key="i">
                            <span v-text="discount.discount_description"></span> - 
                            <span style="margin-left:15px;" v-text="discount.discount_amount +  '₪'"></span>
                        </div>
                    </div>
                    <tr class="total_line" v-if="show_price">
                        <td colspan="4">סה"כ<div style="float:left;" v-text="'₪' + format_number(total_price)"></div></td>
                    </tr>
                </tfoot>
                </table>

                <!-- Order Additions -->
                <div v-if="additions" id="additions_wrapper">
                    <div class="title_small">שינויים בהזמנה</div>
                    <div class="ord_title" v-html="additions.title + ' ' + additions.description"></div>
                    <label>פירוט:</label>
                    <ul>
                        <li v-for="(add,i) in additions.items" :key="i">
                            <div>הלקוח <b>{{ (add.refund == "1" ? "הוריד" : "הוסיף") }}</b>  {{ add.qty }} {{add.name}} <span dir="ltr" style="direction:ltr">   </span></div>
                        </li>
                    </ul>
                </div>
            <!-- Order Additions End -->
            </div>
        </div>
    
    <div class="user_details">
        <h3>מספר הזמנה: {{order.id}}</h3>
        <h4 v-if="order.siblings && order.siblings.length > 0" style="font-size: 24px; margin-top: -15px; margin-bottom: 15px;">הזמנות מקושרות: <router-link v-for="sib in order.siblings" :key="sib" :to="sib">{{sib}}</router-link></h4>

        <h3>פרטי לקוח</h3>
        <ul>
            <li v-for="det in client_details" :key="det.name"><label v-text="det.name"></label><span v-html="det.value"></span></li>

            <li><label>שיטת משלוח</label><span v-text="((order.delivery_type == '1' || order.delivery_type == '0') ? 'איסוף עצמי' : 'משלוח לכניסה לבניין')"></span></li>
            <li v-if="order.delivery_type == '1'"><label>אזור איסוף</label><span v-text="deliveryName"></span></li>
        </ul>
        <div v-if="order.delivery_type == '3'" style="font-size: 23px;text-align: center;font-weight: 600;color: red;">המשלוח הינו לכניסה לבניין בלבד!</div>

        <h3>דגם הסוכה</h3>
        <ul id="first_details" v-if="order.width > 0 && order.door_location != '' || order.prev_x > 0">

            <li v-for="desc in order.desc" :key="desc" v-text="desc"></li>
        </ul>


            <h3>פרטי הזמנה</h3>
        <div class="seller_info">
            <span>שם המוכר/ת: </span><span>{{seller.display_name}}</span>
            <p></p>
            <span>מספר הזמנה: </span><span style="font-weight:bold;">{{order.id}}</span>
            <p></p>
            <span>תאריך הזמנה: </span><span>{{order.date_created}}</span>

            <div style="padding-top:20px;">הנני מאשר/ת שבדקתי וראיתי שקיבלתי את כל הסחורה הנכונה של ההזמנה שלי: <span style="display:inline-block; border-bottom:1px solid #000; width:120px; padding-top: 20px;"></span></div>
        </div>
    </div>
    
    <div class="clr"></div>
       
    <div class="title2 hide-on-small-only" style="text-align: center; font-size:30px;">חג סוכות שמח</div>

   </div>

</template>

<script>
export default {
    props:["order"],
    data(){
        return{
            delivery_price: 0,
            order_data:[],
            show_price: true,
            motot:[],
            comments:[],
            seller:[],
            discounts:[],
            additions:[],
            terms: false,
            summary:[],
            client_details: [
            ],
            accessories: [],
            basket:[],
            motot_summary: [],
            bambook_summary: [],
            lath_summary: [],
            delivery_types: [],
            coupon: '',
            loaded:false
        }
    },
    mounted(){
        if( this.$store.user.id === "96" || this.$store.user.id === "353") this.show_price = false;

        // תעודת משלוח ללא מחיר
        if (this.$route.query.no_price == 'true') this.show_price = false;

        this.$emit('updateSummary');

        this.net_api({action: 'summary', data: {id: this.order.id,print:true, kits: (this.$route.query.kits == 'true') }}, (data) => {
            this.order_data = data.data.data 
            this.additions = data.data.additions;
            this.motot = data.data.motot
            this.seller = data.data.seller
            this.summary = data.data.summary
            this.delivery_types = data.data.delivery_types

            for (let i in data.data.basket)
            {
                let is_active = true;
                for (let z in data.data.basket[i].items)
                {
                    if (data.data.basket[i].items[z].is_active == '0') is_active = false;
                }
                data.data.basket[i].is_active = is_active;
            }

            /*
             * סדר הדפסה ללוגיסטיקה: ברזל, במבוקים ולייסטים (למעלה), ואז
             * בטבלת המוצרים - קטגוריית הסכך קודם ושאר הקטגוריות (בדים וכו')
             * בסדר הרגיל אחריה.
             */
            let basket = Object.values(data.data.basket);
            if (data.data.motot_summary && data.data.motot_summary.length > 0)
            {
                basket.sort((a, b) => ((b.name || '').indexOf('סכך') > -1 ? 1 : 0) - ((a.name || '').indexOf('סכך') > -1 ? 1 : 0));
            }
            this.basket = basket;

            this.motot_summary = (data.data.motot_summary ? data.data.motot_summary : [])
            this.bambook_summary = (data.data.bambook_summary ? data.data.bambook_summary : [])
            this.lath_summary = (data.data.lath_summary ? data.data.lath_summary : [])

            this.accessories = data.data.accessories

            this.discounts = data.data.discounts
            this.delivery_price = data.data.delivery_price

            this.client_details = [
                { name: 'שם מלא', value: '<strong style="font-size:24px;">' + this.order_data.name + '</strong>'},
                { name: 'טלפון', value: '<strong style="font-size:24px;">' + this.order_data.phone + '</strong>'},
                { name: 'דוא"ל', value: this.order_data.email},
                { name: 'רחוב ומספר', value: this.order_data.address},
                { name: 'עיר', value: '<b>' + this.order_data.address_city + '</b>'},
                { name: 'הערות נוספות', value: this.order_data.notes}
            ];

            this.coupon = (this.order_data.discount_amount > 0);

            this.loaded = true

            if (this.userType == 3 || !this.show_price) document.title = 'תעודת משלוח ' + this.order.id;

            /*
             * במחשב של עמדת ההדפסה Chrome רץ עם kiosk-printing, ולכן כל
             * פתיחה של דף הדפסה יוצאת מיד למדפסת. שם מדפיסים אוטומטית רק
             * מתוך העמדה עצמה (station=1); בטאב רגיל שם מדפיסים ב-Ctrl+P.
             * בכל מחשב אחר ההתנהגות נשארת כשהייתה - הדפסה אוטומטית.
             */
            let is_station_frame = (this.$route.query.station == '1');
            let is_station_computer = !this.isNull(localStorage.getItem('print_station_key'));

            /*
             * לפני ההדפסה מכווצים את הדף כך שייכנס בעמוד A4 אחד
             * (ר' fit_to_page). רץ גם ב-Ctrl+P דרך אירוע beforeprint.
             */
            this.$nextTick(() => {
                this.fit_to_page();

                if (is_station_frame || !is_station_computer)
                {
                    setTimeout(() => {
                         this.fit_to_page();
                         window.print();
                    }, 300);
                }
            });
        });

        this._on_before_print = () => { this.fit_to_page(); };
        window.addEventListener('beforeprint', this._on_before_print);
  },
  beforeDestroy(){
      window.removeEventListener('beforeprint', this._on_before_print);
  },
  computed:{

      userType(){
          return this.$store.user.user_type;
      },
      // סיכום הברזל - רק קבוצות פעילות
      active_motot_summary(){
          return this.motot_summary.filter((group) => {
              return (group.is_active !== false && group.is_active != '0');
          });
      },
      // חותמת "שולם" בפינה השמאלית העליונה של ההדפסה
      isPaid(){
          if (this.order_data && this.order_data.is_paid == '1') return true;
          return (this.order && this.order.is_paid == '1');
      },
      total_price_before_discount(){

            let ttl = 0;
            for (let z in this.basket)
            {
                for (let i in this.basket[z].items)
                {
                    if (this.basket[z].items[i].is_active == '1')
                    {
                        ttl += this.basket[z].items[i].price * this.basket[z].items[i].units;
                    }
                }
            }

            // Motot
            for (let z in this.motot_summary)
            {
                if (this.motot_summary[z].is_active) ttl += parseFloat(this.motot_summary[z].total_price);
            }

            // Bambook / Lath
            for (let z in this.bambook_summary)
            {
                if (this.bambook_summary[z].is_active) ttl += parseFloat(this.bambook_summary[z].total_price);
            }
            for (let z in this.lath_summary)
            {
                if (this.lath_summary[z].is_active) ttl += parseFloat(this.lath_summary[z].total_price);
            }

            // Accessories
            let acc_items = this.active_items(this.accessories.items);
            for (let i in acc_items)
            {
                ttl += acc_items[i].price * acc_items[i].units;
            }

          return ttl;
      },

      // סיכומים שלא שויכו לקטגוריה בסל (הגיעו ממוצרים נוספים)
      orphan_summary_groups(){

            let cat_ids = [];
            for (let z in this.basket) cat_ids.push(String(this.basket[z].id));

            return this.bambook_summary.concat(this.lath_summary).filter((group) => {
                if (group.is_active === false || group.is_active == '0') return false;

                return (this.isNull(group.cat_id) || cat_ids.indexOf(String(group.cat_id)) === -1);
            });
      },

      deliveryName(){
        
        let ret = this.delivery_types.filter((row) => { return (row.id == this.order.delivery_type_area) });
        if (!this.isNull(ret) && !this.isNull(ret[0])) return ret[0].name;
        else return '';
      },
      total_price(){

          return this.order_data.total_price;
/*
            let ttl = 0;
            for (let z in this.basket)
            {
                for (let i in this.basket[z].items)
                {
                    ttl += this.basket[z].items[i].price * this.basket[z].items[i].units;
                }
            }

            // Accessories
            for (let i in this.accessories.items)
            {
                ttl += this.accessories.items[i].price * this.accessories.items[i].units;
            }
        

            // DISCOUNT
            if (this.order.discount_amount > 0)
            {
                let discount = this.order.discount_amount;
                if (this.order.discount_is_percent) discount = ttl / 100* this.order.discount_amount

                ttl = ttl - discount;
            }

            // DELIVERY
            if (this.order.delivery_type == 3) ttl += parseFloat(this.delivery_price);


          return ttl;
          */
      }
  },
    methods:{
        /*
         * התאמה לעמוד אחד: הדף רוחבו קבוע כרוחב A4 נטו (ר' CSS), ולכן
         * גובהו על המסך זהה לגובהו בהדפסה. אם הגובה עובר את גובה העמוד
         * נטו - מקטינים ב-zoom עד שנכנס. מתחת ל-MIN_ZOOM הטקסט כבר לא
         * קריא, ואז נותנים לדפדפן לשבור לעמוד שני.
         */
        fit_to_page()
        {
            const MIN_ZOOM = 0.5;
            let page = document.getElementById('print_page');
            if (!page) return;

            page.style.zoom = '';

            // גובה העמוד נטו בפיקסלים (A4 פחות שולי @page)
            let probe = document.createElement('div');
            probe.style.cssText = 'position:absolute; visibility:hidden; height:279mm; width:0;';
            document.body.appendChild(probe);
            let page_h = probe.offsetHeight;
            document.body.removeChild(probe);

            let content_h = page.scrollHeight;
            if (content_h <= page_h) return;

            let zoom = Math.max(MIN_ZOOM, Math.floor((page_h / content_h) * 100) / 100);
            page.style.zoom = zoom;
        },
        // קבוצות הסיכום של הבמבוק/לייסט/חבקים ששייכות לקטגוריה
        /*
         * בהדפסה מוצגים רק פריטים פעילים - מה שכובה בסיכום ולא שולם עליו
         * לא אמור להגיע ללקוח ולא ללקט.
         */
        active_items(items)
        {
            if (this.isNull(items)) return [];

            return items.filter((item) => {
                return (item.is_active != '0' && item.units > 0);
            });
        },
        is_active_group(group)
        {
            return (group.is_active !== false && group.is_active != '0');
        },
        summary_groups(cat_id)
        {
            if (this.isNull(cat_id)) return [];

            return this.bambook_summary.concat(this.lath_summary).filter((group) => {
                return (!this.isNull(group.cat_id) && String(group.cat_id) === String(cat_id) && this.is_active_group(group));
            });
        },
        category_total(category)
        {
            let ttl = 0;
            let items = this.active_items(category.items);
            for (let i in items)
            {
                ttl += items[i].price * items[i].units;
            }

            // שורות הסיכום מוצגות בתוך הקטגוריה - ולכן נכנסות לסה"כ שלה
            let groups = this.summary_groups(category.id);
            for (let g in groups)
            {
                if (groups[g].is_active) ttl += parseFloat(groups[g].total_price);
            }

            return ttl;
        },
    },

}
    
</script>
<style>

    svg,i { width:13px !important; height: 13px !important; vertical-align: middle; }
</style>
<style lang="scss" scoped>
/* רוחב A4 נטו (210mm פחות 8mm שוליים מכל צד) - גם על המסך, כדי
   ש-fit_to_page ימדוד גובה אמיתי */
#print_page { position: relative; width: 194mm; max-width: 100%; margin: 0 auto; }

@media print {
    @page { size: A4; margin: 8mm; }
    #print_page { width: 194mm; max-width: none; margin: 0; }
    .title2 { display: none; }
}
.logistic_box {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 18px;
    line-height: 30px;
    text-align: right;

    div { display: flex; gap: 8px; align-items: baseline; }
    span { font-weight: bold; white-space: nowrap; }
    b { display: inline-block; min-width: 110px; border-bottom: 1px solid #000; font-size: 20px; }
}
.paid_stamp {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 30px;
    font-weight: bold;
    border: 3px solid #000;
    border-radius: 6px;
    padding: 2px 14px;
}
#additions_wrapper{
    .title_small{font-weight: 700;font-size: 20px;text-decoration: underline;}
    label{    font-weight: 700; font-size: 19px;}
}
.logistic_summary{ margin-bottom: 10px; page-break-inside: avoid;
    .title_small{font-weight: 700;font-size: 20px;text-decoration: underline;}
    .motot_group td { background: #d9ead3; font-weight: 700; }
}
.motot_group td { background: #d9ead3; font-weight: 700; }
h3 { font-size: 26px !important; font-weight: bold; text-decoration: underline; margin: 0;}
h3:not(:first-child) { padding-top: 5px; }
.user_details { float:right; width:40%; padding-right: 15px; line-height: 1.3;
    h4 { padding-top: 8px;}
    ul {
        li { display: block;
            label { font-weight: bold; display: inline-block; width:100px;}
            
        }
     }
}

#print { float: right; width:60%;}



table {   border-collapse: collapse; width: 100%; font-size: 16px;
    thead { background: #eee; }
    th, td { padding: 0 8px; line-height: 1.25; border: 1px solid #ddd; }
}

.logo { font-size: 55px;
    &::after, &::before { background: #000;}
}

  .logo_subtitle { margin-top: -16px; margin-bottom: 12px;}

  .print_doc_title { font-size: 28px; font-weight: bold; margin: -10px 0 10px; text-decoration: underline;}

  .company_details { font-size: 15px; line-height: 1.3; margin: -4px 0 12px;}

  .total_line { font-size: 30px; font-weight: bold;}
</style>